// extracted by mini-css-extract-plugin
export default {"base":"feature-module--base--mDCa1","iconBox":"feature-module--icon-box--qqaaB","title":"feature-module--title--XVQdQ"};